import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=7bda648e&scoped=true&"
import script from "./TextTooltip.vue?vue&type=script&lang=js&"
export * from "./TextTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=7bda648e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda648e",
  null
  
)

export default component.exports